<template>
  <section class="grid-flex column">
    <div class="flex w100">
      <div class="box">
        <div class="box-title flex middle">
          <div>
            <h3>Números de WhatsApp</h3>
            
          </div>
          <div class="flex-1 flex end">
            
            <div class=" no-mobile flex column" style="margin-right: 32px">
              Quantidade de Números de Whats: {{ account.used_limits.limit_devices_whats | number }} / {{ account.plan_limits.limit_devices_whats | number }}
              <div class="margin-top-s">Precisa de mais Números? <router-link :to="{ name: 'SubscriptionRedirectParam' , params: { flow: 'whatsapp' }}">Faça Upgrade</router-link></div>
            </div>
            <div class="button primary" @click="openModalCreate()">
              Adicionar Novo WhatsApp
            </div>
            
          </div>
        </div>
        <div class="box-content">
          <ul>
            <li v-for="(w, index) in devices" :key="index">
              <div class="flex row">
                <div class="flex-2">
                  <div><b>{{ w.name }}</b></div>
                  <div class="margin-top-s">
                    Status: {{ _decodeStatus(w.status_evo) }}
                  </div>
                  <div class="margin-top-s">
                    Telefone: {{ w.phone }}
                  </div>
                </div>
                <div class="flex-1 flex end margin-top-s">
                  <div v-if="w.status_evo && w.status_evo != 'open'" class="button secondary" @click="selectedWhats=w; showModalQR = true">Conectar</div>
                  <div class="button secondary" @click="newDevice=w; showModalCreate = true">Editar</div>
                  <div class="button secondary" @click="selectedWhats=w; showModalDelete = true">Deletar</div>
                </div>
              </div>
            </li>
          </ul>
          <div v-if="loading">
            <content-loading>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
            </content-loading>
          </div>
          <div v-if="isEmpty">
            Você não tem dispositivos de whatsapp cadastrados. Adicione o seu primeiro whatsapp.
          </div>
        </div>
      </div>
    </div>

    <!-- modal confirm delete -->
    <modal-confirm
        :show="showModalDelete"
        description="Você tem certeza que deseja deletar esse whatsapp?"
        @cancel="
          showModalDelete = false;
          selectedWhats = null;
        "
        @accept="deleteWhatsApp(selectedWhats)"
      ></modal-confirm>

      <modal
        :title="titleModal"
        :show="showModalCreate"
        @close="cleanModal()"
      >
        <div class="content flex column " slot="content">
          <form autocomplete="off" class="w100">
              <div class="flex-1 w100">
                <label>Nome do Whatsapp</label>
                <input
                  class="input"
                  id="name"
                  type="text"
                  v-model="newDevice.name"
                  autocomplete="off"
                />
              </div>
            </form>
          <div class="flex column w100">
            <div class="flex w100 center margin-top-l">
              <div class="button primary" @click="createOrUpdateWhatsApp()">SALVAR</div>
            </div>
          </div>
        </div>
      </modal>

      <modal
        title="QR CODE"
        :show="showModalQR"
        @close="closeModalQR()"
      >
        <div v-if="selectedWhats" class="content flex column center" slot="content">
          <div class="flex center w100 flex-1">
            <div v-if="loadingQR" class="w100">
              <content-loading>
                <fake-line height="250"></fake-line>
              </content-loading>
            </div>

            <img v-else :src="qrCodeDataURL" width="300" alt="" />
          </div>
          
          <div class="flex column w100">
            <div class="flex w100 center margin-top-l">
              <div class="button primary" @click="closeModalQR()">Fechar</div>
            </div>
          </div>
        </div>
      </modal>

  </section>
</template>

<script>
import { mapState } from "vuex";

import {
  createWhatsApp,
  getWhatsApps,
  deleteWhatsApp,
  updateWhatsApp,
  getWhatsAppStatus,
  getWhatsAppPhone,
  getWhatsAppQRCODE
} from "@/services/whatsapp";

import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";


export default {
  name: "whatsapp",
  components: {
    Modal,
    ModalConfirm
  },
  data() {
    return {
      showModalDelete: false,
      selectedWhats: null,
      showModalQR: false,
      showModalCreate: false,
      loading: false,
      loadingQR: false,
      newDevice: {
        name: '',
        status_evo: 'close',
      },
      devices: [],
      checkStatusQRDevice: null,
      updateQRDevice: null
    };
  },
  watch: {
    showModalQR(v) {
      if (!v) {
        return
      }

      var deviceId = this.selectedWhats.id

      this.getWhatsAppQRCODE(deviceId)
      // update qr in 30s
      this.updateQRDevice = setInterval(() => {
        this.getWhatsAppQRCODE(deviceId)
      }, 30 * 1000)

      // check status
      this.checkStatusQRDevice = setInterval(() => {
        this.getWhatsAppStatus(deviceId)

        var device = this.devices.find(e => e.id === deviceId)

        if (!device) {
          return
        }

        if (device.status_evo && device.status_evo === 'open') {
          this.getWhatsAppPhone(deviceId)
          this.closeModalQR()
        }
      }, 1 * 1000)

    }
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    qrCodeDataURL(){
      if (!this.selectedWhats) {
        return ''
      }
      return this.selectedWhats.qrcode
    },
    titleModal() {
      if (this.newDevice.id) {
        return 'Editar Whatsapp'
      }

      return 'Crirar novo Whatsapp'
    },
    isEmpty() {
      return !this.loading && this.devices && this.devices.length === 0
    },
    alertLimit() {
      if (this.account && this.account.plan_limits.limit_devices_whats <= this.account.used_limits.limit_devices_whats) {
        return true
      }

      return false
    },
  },
  beforeDestroy() {
    clearInterval(this.checkStatusQRDevice)
    clearInterval(this.updateQRDevice)
  },
  mounted() {
    this.getWhatsApps();
  },
  methods: {
    closeModalQR() {
      clearInterval(this.checkStatusQRDevice)
      clearInterval(this.updateQRDevice)
      this.showModalQR = false;
      this.selectedWhats = null
    },
    openModalCreate() {
      if(this.alertLimit) {
        this.$toast.error({
          title:'Erro',
          message:'Você já está usando o limite de números de whatsapp!'
        })

        return

      }
      
      this.showModalCreate = true
    },
    _decodeStatus(status) {
      let _map = {
        'open': 'Conectado',
        'close': 'Desconectado',
        'closed': 'Desconectado'
      }

      return _map[status] || status
    },
    cleanModal() {
      this.newDevice = {
        deviceId: '',
        name: '',
        status_evo: 'close',
      }
      this.showModalCreate = false
    },
    createOrUpdateWhatsApp() {
      if (this.newDevice.id) {
        this.updateWhatsApp()
      } else {
        this.createWhatsApp()
      }
    },
    getWhatsAppStatus(deviceId) {
      getWhatsAppStatus(deviceId)
        .then((result) => {
          let auxDevice = this.devices.find(e => e.id === deviceId)
          auxDevice.status_evo = result.status
        })
    },
    getWhatsAppPhone(deviceId) {
      getWhatsAppPhone(deviceId)
        .then((result) => {
          let auxDevice = this.devices.find(e => e.id === deviceId)
          auxDevice.phone = result.phone
        })
    },
    getWhatsAppQRCODE(deviceId) {
      this.loadingQR = true
      getWhatsAppQRCODE(deviceId)
        .then((result) => {
          this.selectedWhats.qrcode = result.base64

        })
        .finally(() => {
          this.loadingQR = false
        })
      
    },
    createWhatsApp() {
      let data = {
        name: this.newDevice.name,
      };

      if (!data.name) {
        this.$toast.error({
          title: "Erro",
          message: "Você precisa preencher os campos para salvar o whatsapp",
        });
      }
      createWhatsApp(data)
        .then((result) => {
          this.$toast.success({
            title: "Sucesso",
            message: "Whatsapp salva com sucesso",
          });

          this.devices.push(result)
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao tentar salvar whatsapp",
          });
        })
        .finally(() => {
          this.showModalCreate = false
        })
    },
    getWhatsApps() {
      this.loading = true
      getWhatsApps()
        .then((result) => {
          this.devices = result.whatsapps.map(e => Object.assign({
            status_evo: '',
            phone: '',
            qrcode: ''
          }, e))

          // call get devices status
          this.devices.forEach(d => {
            this.getWhatsAppStatus(d.id)
            this.getWhatsAppPhone(d.id)
          })
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao buscar whatsapps",
          });
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateWhatsApp() {
      let params = {
        name: this.newDevice.name
      }
      updateWhatsApp(this.newDevice.id, params)
        .then(() => {
          this.$toast.success({
            title:'Sucesso',
            message:'Editado com sucesso'
          })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
        .finally(() => {
          this.showModalCreate = false
          this.selectedWhats = null
        })
    },
    deleteWhatsApp(whats) {
      deleteWhatsApp(whats.id)
        .then(() => {
          this.$toast.success({
            title:'Sucesso',
            message:'Removido com sucesso'
          })
          this.devices = this.devices.filter(e => e.id != whats.id)
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
        .finally(() => {
          this.showModalDelete = false
          this.selectedWhats = null
        })
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  list-style-type: none;
  border-bottom: 1px solid #dfdfdf;
  margin-bottom: 16px;
  padding: 16px 4px;
  .button {
    margin-right: 8px;
  }
}

</style>
